
import React from 'react'


import "./customicons.css"

export const CircleIcon = ({ disabled, onClick }) => {

  return (
   
    <div >
      <button  className='iconCircle' onClick={onClick}></button>
    </div> 

  )
}
  




